import ReactDOM from "react-dom/client";
import { Provider } from "./components/ui/provider";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/home";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { config } from "./firebase.js";

const app = initializeApp(config);
const analytics = getAnalytics(app);

const root = document.getElementById("root");
const dom = ReactDOM.createRoot(root);

dom.render(
	<Provider>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="*" element={<Navigate to={"/"} replace />} />
			</Routes>
		</BrowserRouter>
	</Provider>,
);
